import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import Form from 'react-bootstrap/Form';
import {Action} from '../../../system/buttons';
import {DirectLink} from '../../welcome/Welcome';
import FontPicker from './FontPicker';
import {Select} from '../../../system/select';

export default class RealTimeGraphWidgetV2Edit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  handleChange = (property) => (value) => {
    let f = {};
    f[property] = value;
    this.setState(f);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    return (
      <>
        <h4>Style</h4>
        <BasicFormElement label={'Line color'}>
          <ColorPicker
            color={this.state.lineColor}
            onChangeComplete={this.handleChange('lineColor')}
          />
        </BasicFormElement>
        <BasicFormElement label={'Line strength'}>
          <Select
            value={this.state.lineStrength}
            onChange={(lineStrength) => this.setState({lineStrength})}
          >
            <option value={'light'}>light</option>
            <option value={'normal'}>normal</option>
          </Select>
        </BasicFormElement>

        <BasicFormElement label={'Font color'}>
          <ColorPicker
            color={this.state.color}
            onChangeComplete={this.handleChange('color')}
          />
        </BasicFormElement>

        <BasicFormElement label={'Font size'}>
          <Form.Control
            type="number"
            value={this.state.fontSize}
            onChange={(e) => this.handleChange('fontSize')(e.target.value)}
          />
        </BasicFormElement>

        <FontPicker
          font={this.state.font}
          onChange={(font) => this.setState({font})}
        ></FontPicker>

        <BasicFormElement label={'Filling mode'}>
          <Select
            value={this.state.fillingMode}
            onChange={(fillingMode) => this.setState({fillingMode})}
          >
            <option value={'one_color'}>One color</option>
            <option value={'gradient'}>Blue-red gradient</option>
            <option value={'none'}>None</option>
          </Select>
        </BasicFormElement>
        {this.state.fillingMode === 'one_color' && (
          <BasicFormElement label={'Filling color'}>
            <ColorPicker
              color={this.state.fillingModeColor}
              onChangeComplete={(fillingModeColor) =>
                this.setState({fillingModeColor})
              }
            />
          </BasicFormElement>
        )}

        {this.state.fillingMode !== 'none' && (
          <BasicFormElement label={'Filling style'}>
            <Select
              value={this.state.fillingStyle}
              onChange={(fillingStyle) => this.setState({fillingStyle})}
            >
              <option value={'solid'}>Solid</option>
              <option value={'gradual_transparency'}>
                Gradual transparency
              </option>
            </Select>
          </BasicFormElement>
        )}

        <hr />

        <h4> Settings</h4>
        <BasicFormElement label={'Duration'}>
          <Select
            value={(this.state.duration / 60_000).toString()}
            onChange={(duration) =>
              this.setState({duration: parseInt(duration) * 60_000})
            }
          >
            <option value={'1'}>1 minute</option>
            <option value={'5'}>5 minutes</option>
            <option value={'10'}>10 minutes</option>
            <option value={'15'}>15 minutes</option>
            <option value={'60'}>60 minutes</option>
          </Select>
        </BasicFormElement>

        <BasicFormElement label={'Show upper/lower heart rate'}>
          <Form.Check
            type="checkbox"
            checked={this.state.showLabel}
            onChange={(e) => this.setState({showLabel: !this.state.showLabel})}
          />
        </BasicFormElement>

        <BasicFormElement label={'Lower limit'}>
          <Form.Control
            value={this.state.min ? this.state.min : 50}
            type={'number'}
            onChange={(e) => this.handleChange('min')(parseInt(e.target.value))}
          />
        </BasicFormElement>

        <BasicFormElement label={'Upper limit'}>
          <Form.Control
            value={this.state.max}
            type={'number'}
            onChange={(e) => this.handleChange('max')(parseInt(e.target.value))}
          />
        </BasicFormElement>

        <Action onClick={() => this.props.onSave(this.state)}>
          Save settings
        </Action>
      </>
    );
  }
}

const BasicFormElement = ({label, children}) => {
  return (
    <Form.Group as={Row}>
      <Form.Label column sm="2">
        {label}
      </Form.Label>
      <Col sm="3">{children}</Col>
    </Form.Group>
  );
};
